import { useFormContext } from 'react-hook-form';
import { Button } from 'semantic-ui-react';
import { FormattedMessage, useIntl } from 'react-intl';
import React from 'react';
import { ShouldRender } from 'components/ShouldRender';
import { useModal } from 'store/modals';
import { DeleteTimeProfile } from '../../../DeleteTimeProfile';
import { useAccessManagement2NModal } from '../../../../../AccessManagement2NModalContext/useAccessManagement2NModal';
import { discardChanges } from '../../../../../../discardChanges';
import styles from './styles.module.scss';

export const FormActions = ({ isLoading, onSubmit }) => {

  const intl = useIntl();
  const modal = useModal();
  const formContext = useFormContext();
  const accessManagement2NContext = useAccessManagement2NModal();

  return (
    <div className={styles.formActions}>
      <div className={styles.actionContainer}>
        <Button
          basic
          name="cancel-time-profile-details"
          type="button"
          disabled={isLoading}
          onClick={() => discardChanges('timeProfile', null, intl, accessManagement2NContext, modal)}
        >
          <FormattedMessage id="cancel" />
        </Button>
        <Button
          name="submit-time-profile-details"
          disabled={isLoading}
          loading={isLoading}
          onClick={formContext.handleSubmit(onSubmit)}
        >
          <FormattedMessage id="saveChanges" />
        </Button>
      </div>
      <ShouldRender condition={!!accessManagement2NContext.selected.timeProfile}>
        <DeleteTimeProfile />
      </ShouldRender>

    </div>
  );
};
